<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Good Psychologist</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="para"> </p>
<p class="image"><a id="page_vi"></a><img alt="Image" src="images/f0vi-01.jpg"/></p>
<p class="center-para1-s">Henry Holt and Company, LLC<br/><em>Publishers since 1866</em><br/>175 Fifth Avenue<br/>New York, New York 10010<br/><a href="http://www.henryholt.com" target="_blank">www.henryholt.com</a></p>
<p class="center-para1-s">Henry Holt<sup>®</sup> and <img alt="Image" src="images/f0vi-02.jpg"/><sup>®</sup> are registered trademarks of<br/>Henry Holt and Company, LLC.</p>
<p class="center-para1-s">Text copyright © 2010 by Noam Shpancer<br/>All rights reserved.</p>
<p class="center-para1-s">Distributed in Canada by H. B. Fenn and Company Ltd.</p>
<p class="center-para1-s">Originally published in Hebrew by Yedioth Sefarim, Tel Aviv, 2009</p>
<p class="center-para1-s">Lyrics from “Long Way Around” by Chris Whitley © 1991 WB MUSIC CORP.<br/>(ASCAP) All Rights Reserved. Used by Permission.</p>
<p class="center-para1-s">Library of Congress Cataloging-in-Publication Data</p>
<p class="para"> </p>
<p class="block-para-s">Shpancer, Noam.</p>
<p class="indent-para-s">[Psikholog ha-tov. English.]</p>
<p class="indent-para-s">The good psychologist : a novel / Noam Shpancer.—1st U.S. ed.</p>
<p class="para2-s">   p. cm.</p>
<p class="indent-para-s">Originally published in Hebrew as Ha-Psikholog ha-tov by Yedioth Sefarim, Tel Aviv, 2009.</p>
<p class="indent-para-s">ISBN: 978-0-8050-9259-2</p>
<p class="para1-ss">1. Psychologists—Fiction. I. Title.</p>
<p class="indent-para-s">PJ5055.41.P345P7513 2010</p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td valign="top"><p class="para1-ss">892.4'37—dc22</p></td>
<td valign="top"><p class="para1-ss">2009046566</p></td>
</tr>
</tbody></table>
<p class="center-para1-s">Henry Holt books are available for special promotions and premiums. For details contact: Director, Special Markets.</p>
<p class="center-para1-s">First U.S. Edition</p>
<p class="center-para1-s">Designed by Kelly S. Too</p>
<p class="center-para1-s">Printed in the United States of America</p>
<p class="center-para1-s">1  3  5  7  9  10  8  6  4  2</p>
<blockquote>
<p class="para-s">This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?66be083c